import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, PawPrint } from "lucide-react";
import { api, storeAuth } from "../lib/api";
import { useAuth } from "../lib/auth";
import { track } from "../lib/analytics";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser, refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const { data } = await api.post(
          "/auth/google/session",
          {},
          { headers: { "X-Session-ID": sessionId } }
        );
        storeAuth({ token: data.token, user: data.user });
        setUser(data.user);
        if (data.is_new_user) {
          track("signup_completed", { method: "google" });
        }
        // Clear hash
        window.history.replaceState(null, "", window.location.pathname);
        // Check if user has dogs; if not, send to onboarding
        try {
          const my = await api.get("/dogs/mine");
          if (!my.data || my.data.length === 0) {
            navigate("/onboarding", { state: { user: data.user } });
            return;
          }
        } catch { /* ignore */ }
        navigate("/search", { state: { user: data.user } });
      } catch {
        await refresh();
        navigate("/login");
      }
    })();
  }, [navigate, setUser, refresh]);

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center bg-brand-cream">
      <div className="flex flex-col items-center gap-3 text-brand-ink/70">
        <span className="w-12 h-12 rounded-full bg-brand-forest text-white flex items-center justify-center">
          <PawPrint className="w-6 h-6" />
        </span>
        <Loader2 className="w-5 h-5 animate-spin text-brand-forest" />
        <div className="text-sm">Signing you in…</div>
      </div>
    </div>
  );
};

export default AuthCallback;
